import React from 'react';
import { Testimonial } from './types';
import { ScrollingColumn } from './ScrollingColumn';
interface TestimonialsProps {
  title?: string;
  subtitle?: string;
  description?: string;
  testimonials?: Testimonial[];
  'data-id'?: string;
}
const defaultTestimonials: Testimonial[] = [{
  id: '1',
  name: 'Adam',
  role: 'Manager',
  company: 'NextGen Tech',
  avatar: 'https://framerusercontent.com/images/aaJKTpeUbtasBySzI40v0ARMVm8.jpg',
  content: 'This task management software has boosted our efficiency by more than 40% and made meeting deadlines effortless.',
  verified: true
}, {
  id: '2',
  name: 'Kyle',
  role: 'Operations Manager',
  company: 'ProCore',
  avatar: 'https://framerusercontent.com/images/BfkVo950OckNgaCN8iEhwVMU2qY.jpg',
  content: 'The user-friendly interface made team onboarding seamless. Even our non-technical members picked it up quickly.',
  verified: true
}, {
  id: '3',
  name: 'Jack',
  role: 'IT Director',
  company: 'CloudWave',
  avatar: 'https://framerusercontent.com/images/xEdLETPjFoftTCdJcckdt3fLo.jpg',
  content: 'With this software, prioritizing tasks has never been easier. I can ensure my team focuses on what truly matters.',
  verified: true
}, {
  id: '4',
  name: 'Morkel',
  role: 'Business Analyst',
  company: 'Visionary',
  avatar: 'https://framerusercontent.com/images/4agecuk0fpCWOUJlzvQJf43jE.jpg',
  content: 'The collaboration features allow my team to stay connected, whether working remotely or in the office',
  verified: true
}, {
  id: '5',
  name: 'Micheal',
  role: 'Senior Marketer',
  company: 'BrandWorks',
  avatar: 'https://framerusercontent.com/images/LQPUSiyINMM3lES7Obflcw20hPo.jpg',
  content: "I love how customizable the software is — we've been able to tailor it exactly to our team's unique workflow and needs.",
  verified: true
}, {
  id: '6',
  name: 'James',
  role: 'Product Manager',
  company: 'InnoTech',
  avatar: 'https://framerusercontent.com/images/dYpvY6nILjnXDZVAqLCeirQZ0.jpg',
  content: "The time tracking tool helped us identify bottlenecks and optimize our processes. It's been a game-changer for our projects",
  verified: true
}, {
  id: '7',
  name: 'David',
  role: 'Team Lead',
  company: 'BrightPath',
  avatar: 'https://framerusercontent.com/images/qf3HqkYepPkkE8DW7I8H1naHBxo.jpg',
  content: 'Having all project data in one place has greatly reduced confusion and significantly improved team accountability.',
  verified: true
}, {
  id: '8',
  name: 'Matthew',
  role: 'Software Engineer',
  company: 'CodeStream',
  avatar: 'https://framerusercontent.com/images/KjiXbqrBrXLUw58QcrZN0DLgQIY.jpg',
  content: "Since using this tool, I feel less overwhelmed. I know exactly what's happening in every project at any given time.",
  verified: true
}, {
  id: '9',
  name: 'Christopher',
  role: 'Program Manager',
  company: 'FusionCorp',
  avatar: 'https://framerusercontent.com/images/dTaxyuwl7FLKlM05Nfn7XcCqAI.jpg',
  content: 'The software has significantly improved our on-time delivery rate. Clients are happier, and so are we!',
  verified: true
}, {
  id: '10',
  name: 'Alexander',
  role: 'CEO',
  company: 'Skyline Innovations',
  avatar: 'https://framerusercontent.com/images/5VYcHxLaP2GvxDxCPJibOSjqlCA.jpg',
  content: 'The reporting features provide actionable insights that help us plan better and avoid repeating mistakes.',
  verified: true
}, {
  id: '11',
  name: 'Benjamin',
  role: 'CEO',
  company: 'TechVerse',
  avatar: 'https://framerusercontent.com/images/lEwofkyx3U5xbdQX5zvVH0i1ko.jpg',
  content: "Assigning tasks and tracking progress has never been so transparent. Everyone knows what they're responsible for.",
  verified: true
}, {
  id: '12',
  name: 'Ryan',
  role: 'Agile Coach',
  company: 'SprintEdge',
  avatar: 'https://framerusercontent.com/images/rB3c1QmPYBbZhY2hJPjoIec7Ic.jpg',
  content: "Managing a remote team felt challenging until we implemented this software. Now, it's as if we're in the same room!",
  verified: true
}];
export function Testimonials({
  title = 'Testimonial',
  subtitle = 'What Says Our Clients',
  description = 'Gain valuable insights and stay in control with AI-driven analytics and tracking tools to keep projects on track from start to finish.',
  testimonials = defaultTestimonials,
  'data-id': dataId
}: TestimonialsProps) {
  // Split testimonials into three columns
  const column1 = testimonials.slice(0, 4);
  const column2 = testimonials.slice(4, 8);
  const column3 = testimonials.slice(8, 12);
  return <div className="relative w-full flex justify-center items-center py-24 md:py-32 px-6 md:px-8 overflow-hidden" data-id="element-1693">
      <div className="relative max-w-[1280px] w-full flex flex-col items-center gap-12 md:gap-16" data-id="element-1694">
        {/* Header Section */}
        <div className="w-full flex flex-col items-center gap-6 text-center px-4 animate-fadeIn" data-id="element-1695">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#3ab795]/10 border border-[#3ab795]/20 backdrop-blur-sm" data-id="element-1696">
            <div className="w-2 h-2 rounded-full bg-[#3ab795] animate-pulse" data-id="element-1697" />
            <p className="text-sm md:text-base font-medium text-[#3ab795] tracking-wide uppercase" data-id="element-1698">
              {title}
            </p>
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#1D1D1D] tracking-tight leading-tight max-w-4xl" data-id="element-1699">
            {subtitle}
          </h2>
          <p className="text-lg md:text-xl leading-relaxed text-gray-600 max-w-2xl font-light" data-id="element-1700">
            {description}
          </p>
        </div>
        {/* Testimonials Columns */}
        <div className="flex gap-4 md:gap-6 items-center justify-center w-full overflow-x-auto lg:overflow-x-visible scrollbar-hide" data-id="element-1701">
          <div className="flex gap-4 md:gap-6 lg:flex-nowrap" data-id="element-1702">
            <ScrollingColumn testimonials={column1} direction="up" speed={15} data-id="element-1703" />
            <ScrollingColumn testimonials={column2} direction="down" speed={15} data-id="element-1704" />
            <ScrollingColumn testimonials={column3} direction="up" speed={15} data-id="element-1705" />
          </div>
        </div>
      </div>
    </div>;
}